<div class="tipcard">
  <div class="content">
    <div class="title">Support us with a tip</div>
    <div class="sub">Ketto charges 0% platform fee, relying solely on donors like you.</div>
  </div>
  <img loading="lazy" data-src="../assets/images/donation-confirmation-img.png" alt="donation-confirmation-img">
</div>